/**
 * Accounts outside TerraIndex that may use the grondverzet feature. The Grondverzet button is
 * internal-only (`requiresTerraIndexUser` in router.js); the accounts below are allowed on top of
 * that, so pilot users at customers can register their own meldingen at OVAM.
 *
 * Matched case-insensitively against the full username (see terraIndexOnlyAccessUtil).
 */
export const GRONDVERZET_USERNAMES = [
  'joachim.jacobs@witteveenbos.com', // Joachim Jacobs, Witteveen+Bos
  'jan.pouillon@abo-group.eu', // Jan Pouillon, ABO NV
  'nele.rodts@abo-group.eu', // Nele Rodts, ABO NV
  'jean.leroy@rimeco.be', // Jean Leroy, Rimeco
  'pieter.hoste@efiglobal.com', // Pieter Hoste, EFI Global
  'kaat.delange@efiglobal.com', // Kaat De Lange, EFI Global
  'emaes@bdb.be', // Ellen Maes, Bodemkundige Dienst van België
  'pme@groupvanvooren.com', // Peter Melkebeke, Groep Van Vooren
  'katrijn.michiels@arcadis.com' // Katrijn Michiels, Arcadis
]
